export const TorneoVacio = {
  anio: null,
  temporada: '',
  anioInicio: null,
  mesInicio: null,
  diaInicio: null,
  fechaFin: null,
  categoria: null,
  tipoTorneo: null,
  pais: null,
  nombre: '',
  cantidadParticipantes: null,
};

export const torneoToDTO = (torneo) => {
  // Si no hay fecha de inicio informada, usar el año del torneo
  const anioInicio = torneo.anioInicio || torneo.anio;

  return {
    anioInicio: anioInicio,
    mesInicio: torneo.mesInicio !== null ? torneo.mesInicio + 1 : null,
    diaInicio: torneo.diaInicio,
    fechaFin: torneo.fechaFin,
    codCategoria: torneo.categoria ? torneo.categoria.codigo : null,
    codTipoTorneo: torneo.tipoTorneo ? torneo.tipoTorneo.codigo : null,
    idPais: torneo.pais ? torneo.pais.id : null,
    descripcion: torneo.nombre,
    temporada: torneo.temporada,
    cantidadParticipantes: torneo.cantidadParticipantes,
  };
};
